<!-- <div class="modal-header">
	<h2>
    <svg width="42" height="38" viewBox="0 0 42 38">
        <g fill="transparent" fill-rule="evenodd" stroke="#0CC5D1" stroke-width="2">
            <path stroke-linecap="square" d="M5.455 19L5.455 35.364 34.545 35.364 34.545 19M5.455 0L0 9.09c-.006 2.525 1.726 4.722 4.182 5.306 2.456.583 4.99-.6 6.122-2.856.914 1.841 2.792 3.006 4.848 3.006S19.086 13.38 20 11.54c.914 1.841 2.792 3.006 4.848 3.006s3.934-1.165 4.848-3.006c1.131 2.257 3.666 3.44 6.122 2.856 2.456-.584 4.188-2.78 4.182-5.305L34.545 0H5.455z" transform="translate(1 1)"/>
            <path d="M16.364 35.364L16.364 24.455 23.636 24.455 23.636 35.364" transform="translate(1 1)"/>
        </g>
    </svg>
    <ng-container i18n="@@products.edit_product">Edit Product</ng-container>

  </h2>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
    <svg version="1.1" x="0px" y="0px" width="14" height="14"  viewBox="0 0 14 14">
      <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
    </svg>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="productForm" (ngSubmit)="submit()" class="add-product" #editProductForm="ngForm">
    <div class="main-product active" item-trigger="add-product">
      <fieldset class="id" [ngClass]="{ 'has-error': (isSubmitted || f.product_number.dirty) && f.product_number?.errors }">
        <label i18n="@@products.id">ID #</label>
        <input type="text" name="id" placeholder="ID" formControlName="product_number"/>
        <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.discount_percent.dirty) && ( f.discount_percent.errors?.max || f.discount_percent.errors?.min)">Invalid</span>
        <span class="field-error" *ngIf="(isSubmitted || f.product_number.dirty) && f.product_number.errors?.required">Required</span>
        <span class="field-error" *ngIf="f.product_number.errors?.serverError">{{ f.product_number.errors?.serverError }}</span>
      </fieldset>

      <fieldset class="pr-name" [ngClass]="{ 'has-error': (isSubmitted || f.name.dirty) && f.name?.errors }">
        <label>
          <ng-container i18n="@@products.product_name"  maxlength="60">Product Name</ng-container>
          <span class="required-star">*</span>
        </label>
        <input type="text" name="product-name" formControlName="name"/>
        <span class="field-error" *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.required">Product name is required</span>
        <span class="field-error" i18n="@@validation.errors.enter_valid_product_name" *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.pattern">Please enter valid product name</span>
        <span class="field-error" i18n="@@validation.errors.product_name_less_than_255_character" *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.maxlength">Product name must be less than 255 characters</span>
        <span class="field-error" *ngIf="f.name.errors?.serverError">{{ f.name.errors?.serverError }}</span>
      </fieldset>

      <div class="mixed-fieldset">

        <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.category_id.dirty) && f.category_id?.errors }">
          <label>
            <ng-container i18n="@@products.product_category">Product Category</ng-container>
            <span class="required-star">*</span>
          </label>
          <select
		        app-select2
		        [options]="{
		          ajax: {url: productCategoriesApi},
		          idColumn: 'id',
              textColumn: 'name',
              tags: true,
              newTag: true,
		          dropdownParent: 'form.add-product',
              lazyLoad: false
		        }"
		        [selected]="productInfo ? {id: productInfo.category_id, text: productInfo.category} : null"
		        i18n-placeholder="@@products.type_category_name" placeholder="Type or Select Category Name"
		        name="category_id"
		        formControlName="category_id"
		       ><option></option></select>
           <span class="field-error" *ngIf="(isSubmitted || f.category_id.dirty) && f.category_id.errors?.required">Category is required</span>
           <span class="field-error" *ngIf="f.category_id.errors?.serverError">{{ f.category_id.errors?.serverError }}</span>
        </fieldset>

        <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.weight.dirty) && f.weight?.errors }">
          <label i18n="@@products.weight">Weight</label>
          <div class="tag-input">
            <input type="number" appPreventScroll name="weight" max="100" formControlName="weight" />
            <span>KG</span>
          </div>
          <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.weight.dirty) && ( f.weight.errors?.max || f.weight.errors?.min)">Invalid</span>
          <span class="field-error" *ngIf="f.product_number.errors?.serverError">{{ f.product_number.errors?.serverError }}</span>
        </fieldset>

        <fieldset class="oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.quantity.dirty) && f.quantity?.errors }">
          <label>
            <ng-container i18n="@@products.available_qty">Available Qty</ng-container>
            <span class="required-star">*</span>
          </label>
          <input type="number" appPreventScroll name="available-qty" formControlName="quantity"/>
          <span class="field-error" *ngIf="(isSubmitted || f.quantity.dirty) && f.quantity.errors?.required">Required</span>
          <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.quantity.dirty) && f.quantity.errors?.min">Invalid</span>
          <span class="field-error" *ngIf="f.quantity.errors?.serverError">{{ f.quantity.errors?.serverError }}</span>
        </fieldset>

        <fieldset class="twoThird" [ngClass]="{ 'has-error': (isSubmitted || f.price.dirty) && f.price?.errors }">
          <label>
            <ng-container i18n="@@products.price">Price</ng-container>
            <span class="required-star">*</span>
          </label>
          <div class="tag-input">
            <input type="number" appPreventScroll name="price" formControlName="price"/>
            <span>{{ basicInfo.currency_symbol }}</span>
          </div>
          <span class="field-error" i18n="@@error.required.price" *ngIf="(isSubmitted || f.price.dirty) && f.price.errors?.required">Price is required</span>
          <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.price.dirty) && f.price.errors?.min">Invalid</span>
          <span class="field-error" *ngIf="f.price.errors?.serverError">{{ f.price.errors?.serverError }}</span>
        </fieldset>

        <fieldset class="oneThird" [ngClass]="{ 'has-error': (isSubmitted || f.discount_percent.dirty) && f.discount_percent?.errors }">
          <label i18n="@@products.discount">Discount</label>
          <div class="tag-input">
            <input type="number" appPreventScroll name="discount" formControlName="discount_percent"/>
            <span>%</span>
          </div>
          <span class="field-error" *ngIf="(isSubmitted || f.discount_percent.dirty) && f.discount_percent.errors">Invalid</span>
          <span class="field-error" *ngIf="f.discount_percent.errors?.serverError">{{ f.discount_percent.errors?.serverError }}</span>
        </fieldset>

        <fieldset class="twoThird">
          <label i18n="@@products.final_price">Final Price</label>
          <div class="tag-input">
            <input type="number" appPreventScroll name="final-price" formControlName="net_price" value="{{ amount }}" />
            <span>{{ basicInfo.currency_symbol }}</span>
          </div>
        </fieldset>
      </div>

      <div class="logo-field-wrapper">
        <fieldset>
          <label i18n="@@products.image">Image</label>
          <file-pond #logoFile
            [options]="pondOptions"
            [files]="productImageUrl"
            (oninit)="pondHandleInit()"
            (onaddfile)="pondHandleAddFile($event)"
            (onprocessfileabort)="pondHandleRemoveFile($event)"
            (onremovefile)="onLOgoDelete($event)"
            >
          </file-pond>
        </fieldset>
      </div>

      <fieldset>
        <label i18n="@@products.description">Description</label>
        <textarea placeholder="Description" formControlName="description"></textarea>
      </fieldset>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="tu-btn pink" (click)="submitted=true;editProductForm.ngSubmit.emit()">
    <span i18n="@@products.update">Update</span>
  </button>
</div> -->

<div class="add_new_product_modal" style="visibility: visible; ">

  <div class="add_new_product_modal-header">
    <h3><ng-container i18n="@@products.edit_product">Edit Product</ng-container></h3>
    <svg class="close_new_product_modal" xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none" (click)="activeModal.dismiss()">
        <path d="M24 8.5L8 24.5M8 8.5L24 24.5" stroke="#646464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  
  <div class="product_details-body">
    <form [formGroup]="productForm" (ngSubmit)="submit()" class="add-product" #editProductForm="ngForm">
      
      <div class="left-column">
        <div class="logo-field-wrapper">
          <fieldset>
            <file-pond #logoFile
              [options]="pondOptions"
              [files]="productImageUrl"
              (oninit)="pondHandleInit()"
              (onaddfile)="pondHandleAddFile($event)"
              (onprocessfileabort)="pondHandleRemoveFile($event)"
              (onremovefile)="onLOgoDelete($event)"
              >
            </file-pond>
          </fieldset>
        </div>
      </div>
      
      <div class="right-column">
        <fieldset class="id" [ngClass]="{ 'has-error': (isSubmitted || f.product_number.dirty) && f.product_number?.errors }">
          <label i18n="@@products.id">ID #</label>
          <input type="text" name="id" placeholder="ID" formControlName="product_number"/>
          <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.discount_percent.dirty) && ( f.discount_percent.errors?.max || f.discount_percent.errors?.min)">Invalid</span>
          <span class="field-error" *ngIf="(isSubmitted || f.product_number.dirty) && f.product_number.errors?.required">Required</span>
          <span class="field-error" *ngIf="f.product_number.errors?.serverError">{{ f.product_number.errors?.serverError }}</span>
        </fieldset>
  
        <fieldset class="pr-name" [ngClass]="{ 'has-error': (isSubmitted || f.name.dirty) && f.name?.errors }">
          <label>
            <ng-container i18n="@@products.product_name"  maxlength="60">Product Name (English)</ng-container>
            <span class="required-star">*</span>
          </label>
          <input type="text" name="product-name" formControlName="name"/>
          <span class="field-error" *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.required">Product name is required</span>
          <span class="field-error" i18n="@@validation.errors.enter_valid_product_name" *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.pattern">Please enter valid product name</span>
          <span class="field-error" i18n="@@validation.errors.product_name_less_than_255_character" *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.maxlength">Product name must be less than 255 characters</span>
          <span class="field-error" *ngIf="f.name.errors?.serverError">{{ f.name.errors?.serverError }}</span>
        </fieldset>

        <fieldset class="pr-name">
          <label>
            <ng-container i18n="@@products.product_name_ar"  maxlength="60">Product Name (Arabic)</ng-container>
          </label>
          <input type="text" name="product-name-arabic" formControlName="name_ar"/>
        </fieldset>

        <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.category_id.dirty) && f.category_id?.errors }">
          <label>
            <ng-container i18n="@@products.product_category">Product Category</ng-container>
            <span class="required-star">*</span>
          </label>
          <select
		        app-select2
		        [options]="{
		          ajax: {url: productCategoriesApi},
		          idColumn: 'id',
              textColumn: 'name',
		          dropdownParent: 'form.add-product',
              lazyLoad: false
		        }"
		        [selected]="productInfo ? {id: productInfo.category_id, text: productInfo.category} : null"
		        i18n-placeholder="@@products.type_category_name" 
            placeholder="Type or Select Category Name"
		        name="category_id"
		        formControlName="category_id"
            [showAddNewItem]="'true'"
						[addNewItemTitle]="addNewCategoryTitle"
            (itemSelected)="onChangeClient($event)"
		       ><option></option>
          </select>
           <span class="field-error" *ngIf="(isSubmitted || f.category_id.dirty) && f.category_id.errors?.required">Category is required</span>
           <span class="field-error" *ngIf="f.category_id.errors?.serverError">{{ f.category_id.errors?.serverError }}</span>
        </fieldset>

        <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.weight.dirty) && f.weight?.errors }">
          <label i18n="@@products.weight">Weight</label>
          <div class="tag-input">
            <input type="number" appPreventScroll name="weight" min="0" max="100" formControlName="weight" />
            <span>KG</span>
          </div>
          <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.weight.dirty) && ( f.weight.errors?.max || f.weight.errors?.min)">Invalid</span>
          <span class="field-error" *ngIf="f.weight.errors?.serverError">{{ f.weight.errors?.serverError }}</span>
        </fieldset>

        <fieldset>
			<label for="preparation_time">
				<ng-container i18n="@@products.preparation_time">Preparation Time</ng-container>
			</label>

			<select nice-select id="preparation_time" name="preparation_time" formControlName="preparation_time">
				<option [value]=null i18n="@@products.instant">Instant</option>
				<option [value]="15">15 <span i18n="@@products.min">mins</span></option>
				<option [value]="30">30 <span i18n="@@products.min">mins</span></option>
				<option [value]="45">45 <span i18n="@@products.min">mins</span></option>
				<option [value]="60">60 <span i18n="@@products.min">mins</span></option>
				<option [value]="90">90 <span i18n="@@products.min">mins</span></option>
				<option [value]="120">120 <span i18n="@@products.min">mins</span></option>
			</select>
		</fieldset>

        <div class="micronutrients_container data-table__wrap">
          <div class="d-flex align-items-center gap-2">
            <div class="custom-checkbox m-0">
              <input type="checkbox" class="select-item show_micronutrients" formControlName="micronutrients">
              <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
              </svg>
              <svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
                <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span i18n="@@product.micronutrients">Micronutrients</span>
          </div>

          <div class="d-grid mt-3 micronutrients-grid" [class.d-none]="!f.micronutrients.value">
            <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.calories.dirty) && f.calories?.errors }">
              <label i18n="@@products.calories">Calories</label>
              <div class="tag-input">
                <input type="number" name="calories" formControlName="calories" appPreventScroll />
                <span i18n="@@product.kcal">kcal</span>
              </div>
              <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.calories.dirty) && ( f.calories.errors?.max || f.calories.errors?.min)">Invalid</span>
              <span class="field-error" *ngIf="f.calories.errors?.serverError">{{ f.calories.errors?.serverError }}</span>
            </fieldset>

            <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.proteins.dirty) && f.proteins?.errors }">
              <label i18n="@@products.proteins">Proteins</label>
              <div class="tag-input">
                <input type="number" name="proteins" formControlName="proteins" appPreventScroll />
                <span i18n="@@product.g">g</span>
              </div>
              <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.proteins.dirty) && ( f.proteins.errors?.max || f.proteins.errors?.min)">Invalid</span>
              <span class="field-error" *ngIf="f.proteins.errors?.serverError">{{ f.proteins.errors?.serverError }}</span>
            </fieldset>

            <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.carbs.dirty) && f.carbs?.errors }">
              <label i18n="@@products.carbs">Carbs</label>
              <div class="tag-input">
                <input type="number" name="carbs" formControlName="carbs" appPreventScroll />
                <span i18n="@@product.g">g</span>
              </div>
              <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.carbs.dirty) && ( f.carbs.errors?.max || f.carbs.errors?.min)">Invalid</span>
              <span class="field-error" *ngIf="f.carbs.errors?.serverError">{{ f.carbs.errors?.serverError }}</span>
            </fieldset>
          </div>
        </div>
        
        <div class="micronutrients_container">
          <div class="d-flex align-items-center gap-2 mb-3 w-100 justify-content-between">
            <label i18n="@@products.addons">Addons</label>
            <svg (click)="addAddon()" class="addOns" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 12.998H13V17.998C13 18.2633 12.8946 18.5176 12.7071 18.7052C12.5196 18.8927 12.2652 18.998 12 18.998C11.7348 18.998 11.4804 18.8927 11.2929 18.7052C11.1054 18.5176 11 18.2633 11 17.998V12.998H6C5.73478 12.998 5.48043 12.8927 5.29289 12.7052C5.10536 12.5176 5 12.2633 5 11.998C5 11.7328 5.10536 11.4785 5.29289 11.2909C5.48043 11.1034 5.73478 10.998 6 10.998H11V5.99805C11 5.73283 11.1054 5.47848 11.2929 5.29094C11.4804 5.1034 11.7348 4.99805 12 4.99805C12.2652 4.99805 12.5196 5.1034 12.7071 5.29094C12.8946 5.47848 13 5.73283 13 5.99805V10.998H18C18.2652 10.998 18.5196 11.1034 18.7071 11.2909C18.8946 11.4785 19 11.7328 19 11.998C19 12.2633 18.8946 12.5176 18.7071 12.7052C18.5196 12.8927 18.2652 12.998 18 12.998Z" fill="#EB1461"/>
            </svg>
          </div>

          <ng-container formArrayName="add_ons">
            <div class="addOns_block" *ngFor="let addon of addons.controls; let i = index" [formGroupName]="i">
              <fieldset class="w-50" [ngClass]="{ 'has-error': isSubmitted && getAddonsFormGroup(i).get('modifier_id')?.errors }">
                <label i18n="@@products.addons">Addons</label>
                <select class="w-100" nice-select id="product-name" formControlName="modifier_id" required>
                  <option *ngFor="let modifier of getAvailableModifiers(i)" [value]="modifier.id">{{ modifier.name }}</option>
                </select>
              </fieldset>
              <fieldset  [ngClass]="{ 'has-error': isSubmitted && getAddonsFormGroup(i).get('min')?.errors }">
                <label i18n="@@products.min">Min</label>
                <input type="number" name="min" min="0" max="100" formControlName="min" appPreventScroll required />
                <small class="field-error" *ngIf="getAddonsFormGroup(i).get('min')?.errors?.min" i18n="@@error.min_must_0">Min must be at least 0</small>
                <small class="field-error" *ngIf="getAddonsFormGroup(i).get('min')?.errors?.max" i18n="@@error.max_exceed">Exceeds max allowed</small>
                <span  class="field-error" i18n="@@error.required" *ngIf="isSubmitted&& getAddonsFormGroup(i).get('min')?.errors?.required">* Required</span>
              </fieldset>
              <fieldset [ngClass]="{ 'has-error': isSubmitted && (getAddonsFormGroup(i).get('max')?.errors || getAddonsFormGroup(i).errors?.maxLessThanMin) }">
                <label i18n="@@products.max">Max</label>
                <input type="number" name="max" min="0" max="100" formControlName="max" appPreventScroll required />
                <span  class="field-error" i18n="@@error.required" *ngIf="isSubmitted&& getAddonsFormGroup(i).get('max')?.errors?.required">* Required</span>
                <small class="field-error" i18n="@@error.min_must_0" *ngIf="getAddonsFormGroup(i).get('max')?.errors?.min">Min must be at least 0</small>
                <small class="field-error" i18n="@@error.max_exceed" *ngIf="getAddonsFormGroup(i).get('max')?.errors?.max">Exceeds max allowed</small>
                <small class="field-error" i18n="@@error.min_must_be_less" *ngIf="getAddonsFormGroup(i).errors?.maxLessThanMin">Max should be greater than min</small>
              </fieldset>
              <!-- <div class="product-name position-relative">
                <label for="product-quantity">Addons</label>
                <select class="form-select" id="product-name" formControlName="modifier_id">
                  <option *ngFor="let modifier of getAvailableModifiers(i)" [value]="modifier.id">
                    {{ modifier.name }}
                  </option>
                </select>
              </div>
              <div class="position-relative">
                <label for="product-quantity">Min</label>
                <input type="number" id="product-price" formControlName="min">
              </div>
              <div class="position-relative">
                <label for="product-quantity">Max</label>
                <input type="number" id="product-price" formControlName="max">
              </div> -->
              <fieldset [ngClass]="{ 'has-error': isSubmitted && getAddonsFormGroup(i).get('modifier_option_id')?.errors?.allOptionsSelected }">
                <label i18n="products.modifier_option">Excluded Options</label>
                <app-tags-input formControlName="modifier_option_id" [options]="modifierOptionsMap[i]" [placeholder]="'Select options'" (dataArrayEmitter)="receiveArray($event,i)"></app-tags-input>
                <!-- Show validation error -->
                <small class="field-error" *ngIf="isSubmitted && getAddonsFormGroup(i).get('modifier_option_id')?.errors?.required">
                  * Required
                </small>
                <small class="field-error" *ngIf="getAddonsFormGroup(i).get('modifier_option_id')?.errors?.allOptionsSelected">
                  You cannot select all options
                </small>
              </fieldset>
              <svg (click)="removeAddon(i)" class="deleteOns" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M16 6.5V5.7C16 4.5799 16 4.01984 15.782 3.59202C15.5903 3.21569 15.2843 2.90973 14.908 2.71799C14.4802 2.5 13.9201 2.5 12.8 2.5H11.2C10.0799 2.5 9.51984 2.5 9.09202 2.71799C8.71569 2.90973 8.40973 3.21569 8.21799 3.59202C8 4.01984 8 4.5799 8 5.7V6.5M3 6.5H21M19 6.5V17.7C19 19.3802 19 20.2202 18.673 20.862C18.3854 21.4265 17.9265 21.8854 17.362 22.173C16.7202 22.5 15.8802 22.5 14.2 22.5H9.8C8.11984 22.5 7.27976 22.5 6.63803 22.173C6.07354 21.8854 5.6146 21.4265 5.32698 20.862C5 20.2202 5 19.3802 5 17.7V6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
          </ng-container>
        </div>

        <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.quantity.dirty) && f.quantity?.errors }">
          <label>
            <ng-container i18n="@@products.available_qty">Available Qty</ng-container>
            <span class="required-star">*</span>
          </label>
          <input type="number" appPreventScroll name="available-qty" formControlName="quantity"/>
          <span class="field-error" *ngIf="(isSubmitted || f.quantity.dirty) && f.quantity.errors?.required">Required</span>
          <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.quantity.dirty) && f.quantity.errors?.min">Invalid</span>
          <span class="field-error" *ngIf="f.quantity.errors?.serverError">{{ f.quantity.errors?.serverError }}</span>
        </fieldset>

        <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.price.dirty) && f.price?.errors }">
          <label>
            <ng-container i18n="@@products.price">Price</ng-container>
            <span class="required-star">*</span>
          </label>
          <div class="tag-input">
            <input type="number" appPreventScroll name="price" formControlName="price"/>
            <span [innerHtml]="basicInfo?.currency_symbol"></span> 
          </div>
          <span class="field-error" i18n="@@error.required.price" *ngIf="(isSubmitted || f.price.dirty) && f.price.errors?.required">Price is required</span>
          <span class="field-error" i18n="@@error.invalid_number" *ngIf="(isSubmitted || f.price.dirty) && f.price.errors?.min">Invalid</span>
          <span class="field-error" *ngIf="f.price.errors?.serverError">{{ f.price.errors?.serverError }}</span>
        </fieldset>

        <fieldset [ngClass]="{ 'has-error': (isSubmitted || f.discount_percent.dirty) && f.discount_percent?.errors }">
          <label i18n="@@products.discount">Discount</label>
          <div class="tag-input">
            <input type="number" appPreventScroll name="discount" formControlName="discount_percent"/>
            <span>%</span>
          </div>
          <span class="field-error" *ngIf="(isSubmitted || f.discount_percent.dirty) && f.discount_percent.errors">Invalid</span>
          <span class="field-error" *ngIf="f.discount_percent.errors?.serverError">{{ f.discount_percent.errors?.serverError }}</span>
        </fieldset>

        <fieldset >
          <label i18n="@@products.final_price">Final Price</label>
          <div class="tag-input">
            <input type="number" appPreventScroll name="final-price" formControlName="net_price" value="{{ amount }}" />
            <span [innerHtml]="basicInfo?.currency_symbol"></span> 
          </div>
        </fieldset>

        <fieldset style="grid-column: span 2; ">
          <label i18n="@@products.description">Description</label>
          <textarea placeholder="Description" formControlName="description"></textarea>
        </fieldset>

        <fieldset style="grid-column: span 2; ">
          <label i18n="@@products.description_ar">Description (Arabic)</label>
          <textarea i18n-placeholder="@@products.description" placeholder="Description"
            formControlName="description_ar"></textarea>
        </fieldset>

        <div *ngIf="isNotBranchAndFoodics()" class="status_wrap store-information--box w-100" style="grid-column: span 2; ">
          <fieldset class="add-categories pb-4">
            <label>
              <ng-container i18n="@@store.add_categories">Inactive In Branches</ng-container>
            </label>
            <select class="categories" app-select2-multiple
              [options]="{ajax: {url: storeFrontBranchApi}, idColumn: 'id',textColumn: 'title'}"
              [selected]="selectedStorefrontBranches ? selectedStorefrontBranches : null"
              i18n-data-placeholder="@@store.add_storefront_categories" data-placeholder="Add Inactive In Branches"
              formControlName="storefront_branches" multiple="multiple"></select>
          </fieldset>
        </div>
      </div>
    </form>
  </div>

  <div class="btn_add_wrapper">
    <button type="button" (click)="submitted=true;editProductForm.ngSubmit.emit()">
      <span i18n="@@products.update">Update</span>
    </button>
  </div>

</div>